import noop from '@gaia/util/noop/action'
import generate from './action/generate'
import create from './action/create'
import edit from './action/edit'
import detail from './action/detail'
import show from './action/show'
import submit from './action/submit'
import error from './action/error'
import insert from './action/insert'

export default {
  index: noop,
  generate,
  new: create,
  edit,
  detail,
  submitOption: submit,
  submitPin: submit,
  show,
  error,
  insert,
}
